import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable, of } from 'rxjs';

import * as fromRoot from '@state/index';
import { Store, select } from '@ngrx/store';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ResultsGuard implements CanActivate {
  constructor(private store: Store<fromRoot.State>, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.store.pipe(
      select(fromRoot.selectSelectedOption), // this selector should have data if inputs exist
      switchMap((res) => {
        if (res !== undefined) {
          return of(true);
        } else {
          this.router.navigate(['/landing-page']);
          return of(false);
        }
      })
    );
  }
}
